module.exports = __webpack_public_path__ + "img/selected5-min.a1646e87.png";